import { useTabContext } from '@ariakit/react';

var useTabs = function useTabs() {
  return useTabContext();
};

export { useTabs };